import React from 'react'
import Lottie from 'lottie-react'

import NoData from '@/components/NoData'
import { INBOX_TYPE_MAP } from '@/reducers/tasks/tasks.constants'

import BaltoWinkingAnimation from '@/assets/lotties/BaltoWinking.json'

export const InboxZero = ({
  isArchive,
  inboxCount = 0,
  archiveCount = 0,
  inboxType,
  currentTab,
  emptyTitle,
  emptyDescription,
}) => {
  const getEmptyState = () => {
    if (isArchive && archiveCount > 0) {
      return (
        <div>
          <h3>No archived tasks match your filters</h3>
          <p>Try adjusting the filters to see more results.</p>
        </div>
      )
    }

    if (!isArchive && inboxCount > 0) {
      return (
        <div>
          <h3>No {INBOX_TYPE_MAP[inboxType]} tasks match your filters</h3>
          <p>Try adjusting the filters to see more results.</p>
        </div>
      )
    }

    if (isArchive) {
      return (
        <div>
          <h3>You have no archived tasks</h3>
          <p>{`When you complete or dismiss tasks, they'll show up here.`}</p>
        </div>
      )
    }

    return (
      <div>
        <h3>{emptyTitle || `You've hit zero!`}</h3>
        <p>{emptyDescription || `You're all caught up. Go enjoy your day!`}</p>
      </div>
    )
  }

  return (
    <NoData hideHeader data-testid={`inbox-tasks-${currentTab.id}-empty`} muted padded>
      <Lottie
        animationData={BaltoWinkingAnimation}
        loop
        style={{ height: '300px', width: '300px', alignSelf: 'center', justifySelf: 'center' }}
      />
      {getEmptyState()}
    </NoData>
  )
}
